import styled from 'styled-components';
import { colors, fontFamily } from '../../../Utils/tokens';

/** Tipografia de "Chat AI / Chat / AI Answer / Examples": 12px / 150%, parágrafos com 12px. */
export const Markdown = styled.div`
  width: 100%;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: ${colors.onSurface};
  word-break: break-word;

  > * + * {
    margin-top: 12px;
  }

  p,
  ul,
  ol,
  blockquote,
  pre,
  table,
  h1,
  h2,
  h3,
  h4 {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4 {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    color: ${colors.onSurface};
  }

  strong {
    font-weight: 600;
  }

  ul,
  ol {
    padding-left: 18px;
  }

  li + li {
    margin-top: 4px;
  }

  a {
    color: ${colors.primary};
    text-decoration: underline;
  }

  code {
    padding: 1px 4px;
    border-radius: 4px;
    background-color: ${colors.surfaceContainer};
    font-size: 11px;
  }

  pre {
    padding: 8px 12px;
    overflow-x: auto;
    border: 1px solid ${colors.surfaceOutline};
    border-radius: 6px;
    background-color: ${colors.surfaceContainer};

    code {
      padding: 0;
      background: none;
    }
  }

  blockquote {
    padding-left: 12px;
    border-left: 2px solid ${colors.surfaceOutline};
    color: ${colors.onSurfaceVariant};
  }

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 6px 8px;
      border: 1px solid ${colors.surfaceOutline};
      text-align: left;
    }

    th {
      background-color: ${colors.surfaceContainer};
      font-weight: 600;
    }
  }

  img {
    display: block;
    max-width: 100%;
    border-radius: 6px;
  }
`;

export const TaskList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;
